// @custom — Product-specific auth page content overrides.
// This file is NEVER overwritten during template sync.
// Override any keys from @system/auth.js here.
//
// Example:
// export default {
//   loginTitle: 'Welcome to MyProduct',
//   registerSubtitle: 'Start building in minutes.',
// }

export default {}
